<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid py-0 " id="procedure-quicksave-container" >
    <div class="row px-0" style="background-color: white; border: 1px solid red;">
      <div class="col-4 pl-2">
        <table style="height:100%">
          <tr>
            <td>
              {{$t('you_have_unsaved_changes')}}
            </td>
          </tr>
        </table>
      </div>
      <div class="col-8 pl-0">
        <button type="button" class="btn btn-success mr-2 mt-2" @click="doSave" style="min-width:80px !important; float:right">{{$t('save')}}</button>
        <button type="button" class="btn btn-warning mr-2 my-2" @click="discardChanges" style="min-width:80px !important; float:right">{{$t('cancel')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../node_modules/axios/index";


  export default {
    name: "procedure-quicksave",
    components: {
      
    },
    props: {

    },
    data() {
      return {
      };
    },
    
    methods: {
      discardChanges() {
        this.$store.commit('discardChanges');
        //vm.$root.$emit('procedure_editor_can_close');
      },
      save() {
        
      },
     
      handleRefresh(val) {

      },
      async doSave() {
        if (this.procedure.ProcedureId != 0) {          
          if (!$('#procedurenameForm').valid())
            return false;
          await this.saveExistingProcedure();
        }
        else {
          await this.saveNewProcedure();
        }
      },

      async saveNewProcedure() {
        var tmpProcedure = { name: this.procedure.ProcedureName, istask: this.procedure.IsTask };
        tmpProcedure.Settings = { Property: [] };
        tmpProcedure.Settings.Property["EnablePrivateChat"] = "True";
        var createProcedureData = JSON.stringify(tmpProcedure);
        var thisContext = this;
        var response = await this.$http.post(
          '/api/Procedure/AddProcedure',
          createProcedureData,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            thisContext.$root.$emit('doSearch');
            var proc = thisContext.procedure;
            proc.ProcedureId = response.data.Id;
            proc.CategoryId = 1;
            this.scheduleid = response.data.ProcedureScheduleId;
            thisContext.procedure = proc;
            thisContext.saveExistingProcedure();
          });
      },

      async saveExistingProcedure() {
        //var request = this.procedure;        
        var request = {
          procedureViewModel: this.procedure,
        };
        try {          
            var response = await this.$http.put(
              '/api/Procedures/v1/UpdateProcedure',
              request,
              {
                headers: {
                  'Content-Type': 'application/json',
                  "Accept": "application/json"
                }
              }
            )
              .then(async response => {
                //alert('doSearch10')
                vm.$root.$emit('doSearch');

                var proc = JSON.parse(JSON.stringify(this.procedure));
                proc.ProcedureId = response.data.ProcedureId;
                proc.CategoryId = response.data.CategoryId
                proc.Description = response.data.Description;
                proc.ProcedureName = response.data.ProcedureName;
                proc.Elements = response.data.Elements;
                //alert(JSON.stringify(proc));
                
                this.$emit('procedure_saved');
                this.$store.commit('loadnewProcedure', proc);
              });
          
        } catch (err) {
        }
      },
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    mounted() {
      this.$root.$emit('procedure_changed', false);
    },

    created: function () {

    },

    watch: {
     
    },
    created() {
      
    },
  };

</script>

<style scoped>
  #procedure-quicksave-container {
    /*border: 1px solid white;*/
  }


</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-quicksave.vue